/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetList200ResponsePagination } from './GetList200ResponsePagination'
import {
  GetList200ResponsePaginationFromJSON,
  GetList200ResponsePaginationFromJSONTyped,
  GetList200ResponsePaginationToJSON,
} from './GetList200ResponsePagination'
import type { RegistryItem } from './RegistryItem'
import {
  RegistryItemFromJSON,
  RegistryItemFromJSONTyped,
  RegistryItemToJSON,
} from './RegistryItem'

/**
 *
 * @export
 * @interface GetList200Response
 */
export interface GetList200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetList200Response
   */
  status: boolean
  /**
   *
   * @type {Array<RegistryItem>}
   * @memberof GetList200Response
   */
  data: Array<RegistryItem>
  /**
   *
   * @type {GetList200ResponsePagination}
   * @memberof GetList200Response
   */
  pagination?: GetList200ResponsePagination
}

/**
 * Check if a given object implements the GetList200Response interface.
 */
export function instanceOfGetList200Response(
  value: object
): value is GetList200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetList200ResponseFromJSON(json: any): GetList200Response {
  return GetList200ResponseFromJSONTyped(json, false)
}

export function GetList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetList200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(RegistryItemFromJSON),
    pagination:
      json['pagination'] == null
        ? undefined
        : GetList200ResponsePaginationFromJSON(json['pagination']),
  }
}

export function GetList200ResponseToJSON(
  value?: GetList200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(RegistryItemToJSON),
    pagination: GetList200ResponsePaginationToJSON(value['pagination']),
  }
}
